import Header from "../../components/header/Header";
import TitleSection from "../../components/TitleSection/Title";
import { Outlet } from "react-router-dom";

const ProductDemo = () => {
    return (
        <div style={{ padding: "10px 20px 10px 20px" }}>
            {/* <Header /> */}
            <TitleSection />
        </div>
    );
};

export default ProductDemo;
